import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Auth from '@Services/Auth';
import LoginForm from './Components/LoginForm';
import LoginAnomousForm from './Components/LoginAnonymousForm';
import LoginPageWrapper from './Components/LoginPageWrapper';

import './Login.custom.scss';
import './Login.theme.scss';

function Login(props) {
  const { isAnonymousUser, cancel, openResetPasswordWithTokenDialog, init, action, notifications, resetState } = props;

  const keyUpListener = (e) => {
    if (e && e.keyCode === 27 && isAnonymousUser) {
      cancel();
    }
  };

  useEffect(() => {
    if (action === 'recoverpassword') {
      openResetPasswordWithTokenDialog();
    }

    if (isAnonymousUser === false && Auth.isReaxysAllowed()) {
      // if named or institution with access to Reaxys
      cancel();
      return;
    }
    init();

    document.addEventListener('keyup', keyUpListener);

    // eslint-disable-next-line consistent-return
    return () => {
      resetState();
      document.removeEventListener('keyup', keyUpListener);
    };
    // eslint-disable-next-line
  }, []);

  return (
    <LoginPageWrapper cancel={cancel} notifications={notifications}>
      <LoginForm {...props} />
      <LoginAnomousForm />
    </LoginPageWrapper>
  );
}

Login.propTypes = {
  isAnonymousUser: PropTypes.bool,
  cancel: PropTypes.func.isRequired,
  openResetPasswordWithTokenDialog: PropTypes.func.isRequired,
  init: PropTypes.func.isRequired,
  notifications: PropTypes.object,
  action: PropTypes.string,
  resetState: PropTypes.func,
};

export default Login;
